import { useEffect, useMemo, useState } from "react"
import TaskBreakdown from "../../../components/ProjectGlance/TaskBreakdown";
import CreatedVsResolved from "../../../components/ProjectGlance/CreatedVsResolved";
import TimeSpentByStatus from "../../../components/ProjectGlance/TimeSpentByStatus";
import services from "../../../services/services";
import _ from "underscore";
import { Urls } from "../../../services/Urls";
import { callautopopulate } from "../../../services/callautopop";
import { dateConvert, dateHoverRange, getFullMonthSelected } from "../../../utils/Helper";
import { useCommon } from "../Pocker/useCommon";
import { DateTime } from "luxon";
import globalFilterStore from "../../../Store/globalFilterStore";
import { useTheme } from "../../../context/ThemeContext";


export const useTaskAnalysis = ({ projectId, tab }) => {

    const { theme } = useTheme();
    const [tabs] = useState([
        {
            label: "Task Breakdown",
            key: "task_breakdown",
            component: <TaskBreakdown projectId={projectId} />
        },
        {
            label: "Created vs Resolved",
            key: "created_vs_resolved",
            component: <CreatedVsResolved projectId={projectId} />
        },
        {
            label: "Time Spent By Status",
            key: "time_spent_by_status",
            component: <TimeSpentByStatus projectId={projectId} />
        },
    ])
    const { getSubProject } = useCommon();
    const [opts, setOpts] = useState({ frequency_type: [], task_breakdown_group: [], logHoursType: [{ label: "Working Hours", value: true }, { label: "24 Hours", value: false }] });
    const [filterValues, setFilterValues] = useState({ frequency_type: "month", date: [], task_breakdown_group: {}, time_spent: { is_working_hours: true, sub_project: null, feature: null, assignee: null, issue_key: "", month: new Date() } })
    const [showDetails, setShowDetails] = useState({ visible: false, tab: tabs?.[0] });
    const [loader, setLoader] = useState(false);
    const [taskColumns, setTaskColumns] = useState([]);
    const [taskRowData, setTaskRowData] = useState({ data: [{ id: "all", title: "", children: [] }], bottom_row_data: [] });
    const [details, setDetails] = useState({ task_breakdown: [], created_vs_resolve: {}, time_spent_by_status: {} });
    const [detailsPopup, setDetailsPopup] = useState({ visible: false, data: {} });
    const store = globalFilterStore();
    const projectWiseData = store.projectWiseData;
    const setProjectWiseData = store.setProjectWiseData;

    useEffect(() => {
        callautopopulate("frequency_type", "task_breakdown_options")?.then(res => {
            setOpts((prev) => ({ ...prev, frequency_type: res?.frequency_type, task_breakdown_group: res?.task_breakdown_options }));
            tab === "task_breakdown" && setFilterValues((prev) => ({ ...prev, task_breakdown_group: _.findWhere(res?.task_breakdown_options, { task_breakdown_key: "issue_type" }) }));
        })
    }, [])

    useEffect(() => {
        if (tab === "task_breakdown" && !_.isEmpty(filterValues?.task_breakdown_group)) {
            getTaskBreakdown();
        } else if (tab === "created_vs_resolved") {
            getCreatedVsResolved();
        } else if (tab === "time_spent_by_status") {
            setFilterOptions();
            getTimeSpentByStatus();
        }
    }, [tab, filterValues?.task_breakdown_group])

    const getTaskBreakdown = async () => {
        try {
            setLoader(true);
            setTaskRowData((prev) => ({ ...prev, data: [{ id: "all", title: "", children: [] }], bottom_row_data: {} }));
            const payload = {
                group_type: filterValues?.task_breakdown_group?.task_breakdown_key || "",
                project_id: projectId
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTTASKBREAKDOWNBYSTATUSSUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.[payload?.group_type];
                let totalData = res?.body?.data?.[`${payload?.group_type}_total`]?.[0];
                const dynamicCols = _.sortBy(res?.body?.data?.issue_status_name, "status_name");

                let obj = { id: "group_id", name: "group_name" };
                // if (payload?.group_type === "assignee") {
                //     obj = { id: "assignee_user_code", name: "user_display_name" };
                // } else if (payload?.group_type === "issue_type") {
                //     obj = { id: "issue_type_id", name: "issue_type_name" };
                // } else if (payload?.group_type === "current_sprint") {
                //     obj = { id: "sprint_id", name: "sprint_name" };
                // }

                if (totalData) {
                    totalData[obj?.name] = "Total";
                }
                setTaskRowData((prev) => ({ ...prev, data: [{ id: "all", title: "", children: _.sortBy(data, obj?.name) }], bottom_row_data: totalData }));
                setDynamicColumns(obj, dynamicCols);
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const setDynamicColumns = (keyObj, cols) => {
        let columns = [{
            key: keyObj?.name,
            label: filterValues?.task_breakdown_group?.task_breakdown_name,
            pinned: "left",
            style: { width: "200px" },
            render: (row) => {
                return (
                    <div className="py-1">{row?.[keyObj?.name]}</div>
                )
            }
        }]
        cols?.forEach(item => {
            columns.push({
                key: item?.status_name,
                label: item?.status_name,
                headerStyle: { textAlign: "center", wordBreak: "break-word" },
                style: { textAlign: "center", width: "90px" },
                render: (row) => {
                    return (
                        <div className={`py-1 ${(row?.[item?.status_name] > 0 && row?.[keyObj?.name] !== "Total") ? "c-pointer text-decoration-underline" : ""}`} onClick={() => { if (row?.[item?.status_name] > 0 && row?.[keyObj?.name] !== "Total") { setDetailsPopup((prev) => ({ ...prev, visible: true, data: { ...row, status_name: item?.status_name, header: `Tasks - ${row?.[keyObj?.name]} - ${item?.status_name}`, group_key: filterValues?.task_breakdown_group?.task_breakdown_key } })) } }}>{row?.[item?.status_name] > 0 ? row?.[item?.status_name] : "-"}</div>
                    )
                }
            })
        })
        columns.push({
            key: "total",
            label: "Total",
            pinned: "right",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "80px" },
            render: (row) => {
                return (
                    <div className="py-1">{row?.total > 0 ? row?.total : "-"}</div>
                )
            }
        })
        setTaskColumns(columns);
    }

    const getCreatedVsResolved = async () => {
        try {
            setLoader(true);
            let from = "";
            let to = "";
            if (filterValues?.date?.[0] && !filterValues?.date?.[1]) {
                setFilterValues((prev) => ({ ...prev, date: [] }));
            } else if (filterValues?.date?.[0] && filterValues?.date?.[1]) {
                from = dateHoverRange(filterValues?.date?.[0]);
                to = dateHoverRange(filterValues?.date?.[1]);
            }
            const payload = {
                from_date: from,
                to_date: to,
                category_key: filterValues?.frequency_type || "",
                project_id: projectId
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTTASKCREATEDVSRESOLVEDSUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.project_task_created_vs_resolved_summary_list;
                const categories = data.map(item => item.category_name);
                const createdTasks = data.map(item => item.created_tasks);
                const resolvedTasks = data.map(item => item.resolved_tasks);

                const min = Math.min(...resolvedTasks, ...createdTasks);
                const max = Math.max(...resolvedTasks, ...createdTasks);
                const tickInterval = Math.ceil(((max - min) / 4));
                setDetails((prev) => ({
                    ...prev, created_vs_resolve: {
                        data: [
                            { name: 'Created Tasks', data: createdTasks },
                            { name: 'Resolved Tasks', data: resolvedTasks, color: '#56b047' }
                        ], xAxis: categories, min, max, tickInterval
                    }
                }));
                setFilterValues((prev) => ({ ...prev, is_change: false }));
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const getTimeSpentByStatus = async (date, key, value) => {
        try {
            setLoader(true);
            const dateRange = date ? getFullMonthSelected(DateTime.fromJSDate(new Date(date))) : (filterValues?.time_spent?.month ? getFullMonthSelected(DateTime.fromJSDate(new Date(filterValues?.time_spent?.month))) : {});
            const payload = {
                project_id: projectId,
                sub_project_id: (key === "sub_project" ? value : filterValues?.time_spent?.sub_project) || 0,
                feature_id: (key === "feature" ? value : filterValues?.time_spent?.feature) || 0,
                requested_user_code: (key === "assignee" ? value : filterValues?.time_spent?.assignee) || 0,
                issue_key: filterValues?.time_spent?.issue_key || "",
                from_date: dateRange?.from_date ? dateConvert(dateRange?.from_date, "iso-string") : "",
                to_date: dateRange?.to_date ? dateConvert(dateRange?.to_date, "iso-string") : "",
                is_working_hours: (key === "is_working_hours" ? value : filterValues?.time_spent?.is_working_hours)
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTTASKTIMESPENTBYSTATUSSUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.project_wise_time_spent_status;
                setDetails((prev) => ({ ...prev, time_spent_by_status: { data: [{ name: "Time Spent", data: _.pluck(data, "total_timespent_days") || [] }], xAxis: _.pluck(data, "status_name") || [], max: Math.max(..._.pluck(data, "total_timespent_days")) } }));
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const setFilterOptions = async () => {
        const data = await getSubProject(projectId, ["is_sub_project", "is_features", "is_project_users"], null);
        setProjectWiseData({ ...projectWiseData, ...data })
    }

    const createdVsResolvedOptions = {
        credits: { enabled: false },
        chart: {
            type: 'spline',
            backgroundColor: theme === "dark" ? "black" : "white",
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: details?.created_vs_resolve?.xAxis,
            gridLineDashStyle: 'dash',
            gridLineColor: theme === "dark" ? "#505152" : "lightgrey",
            gridLineWidth: 1,
            title: "",
            labels: {
                style: {
                    color: theme === "dark" ? "#A9ABAF" : "black"
                }
            }
        },
        yAxis: {
            type: 'number',
            min: details?.created_vs_resolve?.min,
            max: details?.created_vs_resolve?.max,
            tickInterval: details?.created_vs_resolve?.tickInterval,
            title: "",
            labels: {
                style: {
                    color: theme === "dark" ? "#A9ABAF" : "black"
                }
            }
        },
        plotOptions: {
            spline: {
                dataLabels: {
                    enabled: true
                },
            }
        },
        tooltip: {
            shared: true,
            crosshairs: true
        },
        legend: {
            enabled: true,
            verticalAlign: 'top',
            itemStyle: {
                color: theme === "dark" ? "#A9ABAF" : "black"
            }
        },
        series: details?.created_vs_resolve?.data
    };

    const timeSpentByStatusOptions = {
        credits: { enabled: false },
        chart: {
            type: 'bar',
            backgroundColor: theme === "dark" ? "black" : "white",
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: details?.time_spent_by_status?.xAxis,
            gridLineDashStyle: 'dash',
            gridLineColor: theme === "dark" ? "#505152" : "lightgrey",
            gridLineWidth: 1,
            title: "",
            labels: {
                style: {
                    color: theme === "dark" ? "#A9ABAF" : "black"
                }
            }
        },
        yAxis: {
            min: 0,
            max: details?.time_spent_by_status?.max,
            title: "",
            labels: {
                style: {
                    color: theme === "dark" ? "#A9ABAF" : "black"
                }
            }
        },
        tooltip: {
            valueSuffix: ' days'
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            bar: {
                pointWidth: 25,
                dataLabels: {
                    enabled: true
                },
            }
        },
        series: details?.time_spent_by_status?.data
    }

    const changeMonth = (delta) => {
        const newDate = new Date(filterValues?.time_spent?.month.getFullYear(), filterValues?.time_spent?.month.getMonth() + delta, 1);
        setFilterValues((prev) => ({ ...prev, time_spent: { ...prev?.time_spent, month: newDate }, is_change: true }));
        getTimeSpentByStatus(newDate);
    };

    return useMemo(() => ({
        showDetails, setShowDetails, tabs, taskColumns, taskRowData, createdVsResolvedOptions, filterValues, setFilterValues, opts, getCreatedVsResolved, loader, timeSpentByStatusOptions, detailsPopup, setDetailsPopup, projectWiseData, getTimeSpentByStatus, changeMonth
    }), [showDetails, setShowDetails, tabs, taskColumns, taskRowData, createdVsResolvedOptions, filterValues, setFilterValues, opts, getCreatedVsResolved, loader, timeSpentByStatusOptions, detailsPopup, setDetailsPopup, projectWiseData, getTimeSpentByStatus, changeMonth])
}